import {
  brandclub_colors,
  MOBILE_SCREEN_SIZE,
  TABLET_SCREEN_SIZE,
} from "@brandclub/common-ui";
import { styled } from "@mui/material";

export const ReviewCoverContainer = styled("div", {
  label: "ReviewCoverContainer",
})(({ theme }) => ({
  padding: "20px 40px",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  width: "100%",
  flex: 1,
  [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    padding: "20px 20px",
  },
}));

export const ReviewQuestionContainer = styled("div", {
  label: "ReviewQuestionContainer",
})(({ theme }) => ({
  padding: "20px 40px",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  width: "100%",
  flex: 1,
  [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    padding: "20px 20px",
  },
}));

export const ReviewCoverInfo = styled("div", {
  label: "ReviewCoverInfo",
})(({ theme }) => ({
  padding: "50px 20px",
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  ">div": {
    maxWidth: 512,
  },
}));

export const ReviewCoverTitle = styled("h1", {
  label: "ReviewCoverTitle",
})(({ theme }) => ({
  margin: 0,
  marginBottom: 11,
  fontSize: 24,
  fontWeight: 700,
  color: theme.vars.palette.text.primary,
  textAlign: "center",
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    fontSize: 24,
  },
}));

export const ReviewCoverSubtitle = styled("h2", {
  label: "ReviewCoverSubtitle",
})(({ theme }) => ({
  margin: 0,
  fontSize: 20,
  fontWeight: 500,
  marginBottom: 30,
  color: theme.vars.palette.text.primary,
  textAlign: "center",
  maxWidth: "385px !important",
  WebkitLineClamp: 3,
  lineHeight: 1.5,
  height: `4.5em`, // line height * 3
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical",
  width: "100%",
  [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    fontSize: 16,
  },
}));

export const ReviewInfo = styled("div", {
  label: "ReviewInfo",
})(({ theme }) => ({
  padding: "30px 20px",
  maxWidth: 746,
  width: "100%",
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "30px",
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    padding: "20px 20px",
  },
}));

export const ReviewSection = styled("section", {
  label: "Section",
})(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const ReviewSummaryLogo = styled("div", { label: "SummaryLogo" })(
  ({ theme }) => ({
    width: 200,
    height: 200,
    objectFit: "contain",
  })
);
export const ReviewTitle = styled("h1", { label: "Title" })(({ theme }) => ({
  margin: 0,
  marginBottom: 10,
  fontSize: 24,
  fontWeight: 700,
  color: theme.vars.palette.text.primary,
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    fontSize: 18,
  },
}));
export const ReviewLabel = styled("label", { label: "ReviewLabel" })(
  ({ theme }) => ({
    margin: 0,
    marginBottom: 24,
    fontSize: 20,
    fontWeight: 700,
    color: theme.vars.palette.text.primary,
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 16,
      marginBottom: 20,
    },
  })
);

export const ReviewTwolineText = styled("p", { label: "TwolineText" })(
  ({ theme }) => ({
    margin: 0,
    overflow: "hidden",
    WebkitLineClamp: 2,
    lineHeight: 1.5,
    height: `3em`,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    wordBreak: "break-word",
  })
);
export const ReviewSubtitle = styled("p", { label: "Subtitle" })(
  ({ theme }) => ({
    margin: 0,
    fontSize: 16,
    fontWeight: 500,
    color: theme.vars.palette.text.primary,
    [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 10,
    },
  })
);
export const ReviewSelections = styled("div", { label: "ReviewSelections" })(
  ({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: 30,
    [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      marginTop: 20,
    },
  })
);
export const ReviewAddComments = styled("div", { label: "AddComments" })(
  ({ theme }) => ({
    marginTop: 60,
    display: "flex",
    flexDirection: "column",
    flex: 1,
  })
);

export const ReviewSummaryTitle = styled("h2", {
  label: "SummaryTitle",
})(({ theme }) => ({
  margin: 0,
  marginBottom: 10,
  fontSize: 20,
  fontWeight: 600,
  color: theme.vars.palette.text.primary,
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    fontSize: 18,
  },
}));
export const ReviewDesc = styled("div", { label: "Desc" })(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  color: theme.vars.palette.text.primary,
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    fontSize: 14,
  },
}));

export const ReviewTextInputWrapper = styled("div", {
  label: "TextInputWrapper",
})(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
}));

export const TextAreaInputBox = styled("textarea", {
  label: "TextAreaInputBox",
  shouldForwardProp: (prop) => prop !== "single",
})<{ single?: boolean; component?: "input" | "textarea" }>(
  ({ theme, single }) => ({
    outline: "none",
    resize: "none",
    width: "100%",
    borderRadius: "8px",
    padding: "21px",
    fontSize: 16,
    fontWeight: 500,
    color: theme.vars.palette.text.primary,
    height: single ? 54 : "100%",
    maxHeight: "378px",
    boxSizing: "border-box",
    border: `1px solid #dcdddc`,
    backgroundColor: "#f6f8fa",
    [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 14,
      padding: "15px",
      height: single ? 72 : undefined,
    },
    "&:disabled": {
      backgroundColor: "#f6f8fa",
    },
    "&::placeholder": {
      color: brandclub_colors.darkBlue5,
    },
  })
);
export const TextInputBox = styled("input", {
  label: "TextInputBox",
  shouldForwardProp: (prop) => prop !== "single",
})<{ single?: boolean; component?: "input" | "textarea" }>(
  ({ theme, single }) => ({
    outline: "none",
    resize: "none",
    width: "100%",
    borderRadius: "8px",
    padding: "21px",
    fontSize: 16,
    fontWeight: 500,
    color: theme.vars.palette.text.primary,
    height: single ? 54 : "100%",
    maxHeight: "474px",
    boxSizing: "border-box",
    border: `1px solid #dcdddc`,
    backgroundColor: "#f6f8fa",
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 14,
      padding: "15px",
      height: single ? 72 : undefined,
    },
    "&:disabled": {
      backgroundColor: "#f6f8fa",
    },
    "&::placeholder": {
      color: brandclub_colors.darkBlue5,
    },
  })
);

export const ReviewCoverLogo = styled("img", { label: "ReviewCoverLogo" })(
  ({ theme }) => ({
    maxWidth: 225,
    maxHeight: 225,
    objectFit: "contain",
    borderRadius: 5,
    aspectRatio: 1,
  })
);
